import { render, staticRenderFns } from "./SystemMatchIndicator.vue?vue&type=template&id=e5435fea&scoped=true&"
import script from "./SystemMatchIndicator.vue?vue&type=script&lang=js&"
export * from "./SystemMatchIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SystemMatchIndicator.vue?vue&type=style&index=0&id=e5435fea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5435fea",
  null
  
)

export default component.exports